import Vue from 'vue'
import VueI18n from 'vue-i18n'

import tw from '@/lang/i18n/tw/lang.js'

Vue.use(VueI18n)

const locale = 'tw'

const messages = {
  tw
}

const i18n = new VueI18n({
  locale,
  messages
})

export default i18n
